import './utility/dynamics-tz';
import './services/navigation/component-registrations';
import {MbscModule} from '@mobiscroll/angular';
import {CdkTableModule} from '@angular/cdk/table';
import {HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BuildInfo} from '@awesome-cordova-plugins/build-info/ngx';
import {ChartModule} from 'angular-highcharts';
import {ServerErrorsInterceptor} from './services/error-handler/server-error.interceptor';
import {GlobalErrorHandler} from './services/error-handler/error-handler-service';
import {FileManagerEffects} from './store/io-file-service/effects/file.effect';
import {ResourceManagerEffects} from './store/io-file-service/effects/resource.effect';

import {CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, Injectable, isDevMode, NgModule} from '@angular/core';
import {BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule} from '@angular/platform-browser';
import {StatusBar} from '@awesome-cordova-plugins/status-bar/ngx';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {TokenInterceptor} from './interceptors/token.interceptor';
import {MyApp} from './app.component';


import {Network} from '@awesome-cordova-plugins/network/ngx';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
//Resources
import {FileTransfer} from '@awesome-cordova-plugins/file-transfer/ngx';
import {File} from '@awesome-cordova-plugins/file/ngx';
import {FileOpener} from '@awesome-cordova-plugins/file-opener/ngx';

import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {appReducers} from './store/application.reducer';
import {INITIAL_APP_STATE} from './store/application.state';

import {Clipboard} from '@awesome-cordova-plugins/clipboard/ngx';
import {NativePageTransitions} from '@awesome-cordova-plugins/native-page-transitions/ngx';

import {InAppBrowser} from '@awesome-cordova-plugins/in-app-browser/ngx';
// idle module and moment js stuff
import {Deeplinks} from '@awesome-cordova-plugins/deeplinks/ngx';
import {ScreenOrientation} from '@awesome-cordova-plugins/screen-orientation/ngx';
import {Diagnostic} from '@awesome-cordova-plugins/diagnostic/ngx';
import {SecureStorage,} from '@awesome-cordova-plugins/secure-storage/ngx';

//
import {AndroidPermissions} from '@awesome-cordova-plugins/android-permissions/ngx';

import {LaunchDarklyProvider} from './providers/launch-darkly/launch-darkly';
import {BarcodeScanner} from '@awesome-cordova-plugins/barcode-scanner/ngx';
//
import {TranslateCompiler, TranslateLoader, TranslateModule,} from '@ngx-translate/core';
import {TranslateMessageFormatCompiler} from 'ngx-translate-messageformat-compiler';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import Hammer from 'hammerjs';
import {Device} from '@awesome-cordova-plugins/device/ngx';


import {VirtualListModule} from './components/angular-virtual-list';
import {PdfJsViewerModule} from 'ng2-pdfjs-viewer';


import {DragDropModule} from '@angular/cdk/drag-drop';
import {RouteReuseStrategy, RouterModule} from '@angular/router';
import {OfflineSyncUtility} from './utility/offline-sync.utility';
import {components, standaloneComponents} from './components';
import { SharedModule } from './shared/shared.module';
import { MedicalInquiryModule } from './components/medical-inquiry/medical-inquiry.module';
import { CaseManagementModule } from './components/case-management/case-management.module';
import { AssessmentModule } from './components/assessment/assessment.module';
import { ActivityModule } from './components/activity/activity.module';
import { EventsToolModule } from './components/events-tool/events-tool.module';
import { GoAppModule } from './components/go-app/go-app.module';
import { AccountModule } from './components/account/account.module';
import { EmailModule } from './components/email/email.module';
import { ContactModule } from './components/contact/contact.module';
import { SampleModule } from './components/sample/sample.module';
import { IoModule } from './components/io-component/io.module';
import {SocialSharing} from '@awesome-cordova-plugins/social-sharing/ngx';
import {PaginatorModule} from 'primeng/paginator';
import {EditorModule, TINYMCE_SCRIPT_SRC} from '@tinymce/tinymce-angular';
import {OpentokModule} from './components/opentok/ot.module';
import {DatePipe, NgOptimizedImage} from '@angular/common';
import {CalendarModule} from '@exeevo/ion2-calendar';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {Keyboard} from '@awesome-cordova-plugins/keyboard/ngx';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {TooltipModule} from '@amin-karimi/ng2-tooltip-directive';
import {QRCodeModule} from 'angularx-qrcode';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CameraPreview} from '@awesome-cordova-plugins/camera-preview/ngx';
import { AI_TOOL_REGISTRY_PROVIDERS } from './ai/tools/client-tools';
import { APPOINTMENT_REF_RESOLVER_PROVIDER } from './services/meeting/appointment-ref-resolver.provider';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


class ConditionalTranslateCompiler implements TranslateCompiler {
  private readonly messageFormat = new TranslateMessageFormatCompiler();

  compile(value: string, lang: string): any {
    if (this.#containsICU(value)) {
      return this.messageFormat.compile(value, lang);
    }
    return value;
  }

  compileTranslations(translations: any, lang: string): any {
    return Object.keys(translations).reduce((acc, key) => {
      acc[key] = this.compile(translations[key], lang);
      return acc;
    }, {});
  }

  #containsICU(value: string): boolean {
    return /{\s*[\w.]+\s*,\s*(plural|select|selectordinal)\s*,/.test(value);
  }
}

@Injectable()
export class hammerConfig extends HammerGestureConfig {
  overrides = {
    swipe: { velocity: 0.4, threshold: 20, direction: Hammer.DIRECTION_ALL}, // override default settings
  } as any;
}

@NgModule({
  declarations: [...components],
    imports: [
        SharedModule,
        MedicalInquiryModule,
        CaseManagementModule,
        AssessmentModule,
        ActivityModule,
        EventsToolModule,
        GoAppModule,
        AccountModule,
        EmailModule,
        ContactModule,
        SampleModule,
        IoModule,
        MbscModule,
        ScrollingModule,
        OpentokModule,
        ReactiveFormsModule,
        VirtualListModule,
        PdfJsViewerModule,
        PdfViewerModule,
        TranslateModule, // translate Module
        DragDropModule,
        RouterModule.forRoot([], {}),
        FormsModule,
        IonicModule.forRoot({
          animated: false,
          mode: 'ios',
          swipeBackEnabled: false,
          scrollAssist: false
        }),
        BrowserModule,
        BrowserAnimationsModule,
        ChartModule,
        CdkTableModule,
        HammerModule,
        PaginatorModule,
        StoreModule.forRoot(appReducers, {initialState: INITIAL_APP_STATE}),
        EffectsModule.forRoot([FileManagerEffects, ResourceManagerEffects]),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
            compiler: {
              provide: TranslateCompiler,
              useClass: ConditionalTranslateCompiler,
            }
        }),
        EditorModule,
        CalendarModule.forRoot({
            doneLabel: 'Save',
            closeIcon: true,
            canBackwardsSelected: true,
        }),
        NgxMaterialTimepickerModule,
        TooltipModule.forRoot({
            'placement': 'bottom',
            'show-delay': 200,
            'theme': 'light',
            'displayTouchscreen': true,
            // Time-to-readable is show-delay PLUS this fade (the component's CSS is
            // `transition: opacity .3s`, and setAnimationDuration only overrides it when this
            // differs from animationDurationDefault). At the stock 300ms a tooltip took ~500ms
            // to become legible — longer than it takes to sweep between side rail icons, so
            // you only ever saw the previous icon's tooltip over the current one.
            'animation-duration': 100,
            'tooltip-class': 'custom-tooltip',
            'offset': 4,
            // NB: do not reintroduce 'display-mobile'. The library's backward-compatibility
            // map renames it onto displayTouchscreen, and renameProperties overwrites in key
            // order — so 'display-mobile': false silently beat the displayTouchscreen: true
            // above it. That made isDisplayOnHover false on any touch-CAPABLE device
            // ('ontouchstart' in window — a Surface on a mouse qualifies), so onMouseEnter
            // returned early and no tooltip was ever created.
        }),
        QRCodeModule,
        NgOptimizedImage,
        ...standaloneComponents,
      ],
  bootstrap: [MyApp],
  providers: [
    CameraPreview,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorsInterceptor,
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    StatusBar,
    BuildInfo,
    Network,
    DatePipe,
    File,
    Deeplinks,
    SecureStorage,
    FileTransfer,
    FileOpener,
    Clipboard,
    NativePageTransitions,
    InAppBrowser,
    Diagnostic,
    ScreenOrientation,
    ErrorHandler,
    BarcodeScanner,
    //{ provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },

    AndroidPermissions,

    LaunchDarklyProvider,

    OfflineSyncUtility,
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: hammerConfig
    },

    Device,
    DatePipe,
    SocialSharing,
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
    Keyboard,
    ...AI_TOOL_REGISTRY_PROVIDERS,
    APPOINTMENT_REF_RESOLVER_PROVIDER,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule {
  constructor(){
    console.log('module');
  }
}
